import {combineReducers} from "redux";
import buyInOneClick from "../ducks/buy-in-one-click";
import authenticityToken from "../ducks/authenticity-token";
import breadcrumbs from "../ducks/breadcrumbs";
import product from "../ducks/product";
import seo from "../ducks/seo";
import locationData from "../ducks/location-data";
import reviews from "../ducks/reviews";
import url from "../ducks/url";
import cartInfo from "../ducks/cart-info";
import isAdmin from "../ducks/is-admin";
import licenseeStore from "../ducks/licensee-store";

export default combineReducers({
  url,
  authenticityToken,
  breadcrumbs,
  product,
  buyInOneClick,
  seo,
  locationData,
  reviews,
  cartInfo,
  isAdmin,
  licenseeStore
});
